/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q1Inputs */

const en_viewer_faq_q1 = /** @type {(inputs: Viewer_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my JSON data sent to any server?`)
};

const ko_viewer_faq_q1 = /** @type {(inputs: Viewer_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 데이터가 서버로 전송되나요?`)
};

const ja_viewer_faq_q1 = /** @type {(inputs: Viewer_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONデータはサーバーに送信されますか？`)
};

/**
* | output |
* | --- |
* | "Is my JSON data sent to any server?" |
*
* @param {Viewer_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q1 = /** @type {((inputs?: Viewer_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q1(inputs)
	if (locale === "ko") return ko_viewer_faq_q1(inputs)
	return ja_viewer_faq_q1(inputs)
});